var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as _ from "lodash";
import Icon from './Icon';
import styled from 'styled-components';
import { appendPx } from '../theme/DefaultTheme';
import { fadeColor, getColor } from '../helpers/ColorHelpers';
var OuterContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: fit-content;\n    display: inline-block;\n"], ["\n    width: fit-content;\n    display: inline-block;\n"])));
var Total = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    float: right;\n    margin-top: ", ";\n    margin-left: -2px;\n    font-size: ", ";\n    font-weight:lighter;\n    text-align:", ";\n    border-radius: ", ";\n    height: ", ";\n    width: ", ";\n    line-height: ", ";\n    background: ", ";\n    box-shadow: 0 5px 3px -4px ", ";\n    opacity: ", "; \n"], ["\n    float: right;\n    margin-top: ", ";\n    margin-left: -2px;\n    font-size: ", ";\n    font-weight:lighter;\n    text-align:", ";\n    border-radius: ", ";\n    height: ", ";\n    width: ", ";\n    line-height: ", ";\n    background: ", ";\n    box-shadow: 0 5px 3px -4px ", ";\n    opacity: ", "; \n"])), function (p) { return p.showTotalRounded ? "3px" : "-4px"; }, function (p) { return p.showTotalRounded ? "0.7rem" : "0.65rem"; }, function (p) { return p.showTotalRounded ? "center" : "left"; }, function (p) { return p.showTotalRounded ? appendPx(p.height) : 0; }, function (p) { return p.showTotalRounded ? appendPx(p.height) : "unset"; }, function (p) { return p.showTotalRounded ? appendPx(p.height) : "unset"; }, function (p) { return p.showTotalRounded ? appendPx(p.height) : "unset"; }, function (p) { return p.showTotalRounded ? fadeColor(p, getColor(p, p.theme.colors.mainBackground), 70) : "unset"; }, function (p) { return p.showTotalRounded ? fadeColor(p, getColor(p, p.theme.colors.darkGrey), 70) : "unset"; }, function (p) { return p.showTotalRounded ? "unset" : "0.7"; });
var RatingView = /** @class */ (function (_super) {
    __extends(RatingView, _super);
    function RatingView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    RatingView.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        var rating = Math.round(this.props.rating * 10) / 10;
        var fullStars = Math.floor(rating);
        var emptyStars = Math.floor(this.props.maxStars - rating);
        var halfStar = fullStars + emptyStars === this.props.maxStars ? false : true;
        return (React.createElement(OuterContainer, null,
            _.times(fullStars, function (i) {
                var _a;
                return React.createElement(Icon, { key: i, size: (_a = _this.props.size) !== null && _a !== void 0 ? _a : 16, name: "star full", marginTop: 0, style: { marginRight: 5 } });
            }),
            halfStar &&
                React.createElement(Icon, { size: (_a = this.props.size) !== null && _a !== void 0 ? _a : 16, name: "star half", marginTop: 0, style: { marginRight: 5 } }),
            _.times(emptyStars, function (j) {
                var _a;
                return React.createElement(Icon, { key: j, size: (_a = _this.props.size) !== null && _a !== void 0 ? _a : 16, name: "star empty", marginTop: 0, style: { marginRight: 5 } });
            }),
            this.props.showTotal &&
                React.createElement(Total, { height: (_b = this.props.size) !== null && _b !== void 0 ? _b : "16px", showTotalRounded: (_c = this.props.showTotalRounded) !== null && _c !== void 0 ? _c : false }, rating)));
    };
    return RatingView;
}(React.Component));
export default RatingView;
var templateObject_1, templateObject_2;
//# sourceMappingURL=RatingView.js.map